@if (space) {
  <div class="space-detail-page">
    <div id="space-detail-content">
      <router-outlet></router-outlet>
    </div>
  </div>
}
